import PlainInput from './PlainInput';

export default PlainInput;



// WEBPACK FOOTER //
// ./src/client/Components/Forms/PlainInput/index.js